import RichText from './RichText';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

RichText.schema = schema;
RichText.defaultProps = getEmptyDefaultProps(schema.propsSchema);

export default RichText;
